var Backbone = require('backbone');
var _ = require('underscore');
var dispatcher = require('./../dispatcher');
// var toastr = require('toastr');
const toastr = require('../helpers/toastr-config');
const notifications = require('../helpers/custom-notifications');
var customConfirm = require("../helpers/custom-confirm");


var STATUSES = {
	DEFAULT: 0,
	UPDATED: 1,
	DELETED: 2,
	NEW: 3,
	NEW_PREINSERTED: 4,
	UNKNOWN: 5,
	DELETED_PERMANENTLY: 6
};
var CLASS_NAMES = {
	0: 'default',
	1: 'updated',
	2: 'deleted',
	3: 'new',
	4: 'new',
	5: 'unknown'
};

var SubtitleModel = Backbone.Model.extend({
	defaults: {
		id: null,
		editStackPosition: 0,
		editStack: null,
		frameRate: null,
		status: STATUSES.DEFAULT,
		hasBox: false
	},

	dataKeys: [
		'italic',
		'frameEnd',
		'frameStart',
		'row1',
		'row2',
		'hasBox',
		'position'
	],

	modelKeys: {},

	initialize: function () {
		this.set('editStack', new Backbone.Collection());

		this.initEventListeners();
	},

	initEventListeners: function () {
		this.listenTo(dispatcher, dispatcher.events.BUILD_SETTINGS_CSS, this.buildSettingsCss);
		this.listenTo(dispatcher, dispatcher.events.RESET_SETTINGS_CSS, this.resetSettingsCss);
	},
	setData: function (data, status, force) {
		// if (stack.length) return;

		this.set({
			id: this.id || data['id'] || null,
			status: status ? status : STATUSES.DEFAULT,
			translationId: data['translationId'] || this.get('translationId'),
			maxCharactersInLine: data['maxCharactersInLine'],
			hasBox: data['hasBox']
		});
		 
		var model = {};

		_.each(this.dataKeys, function (key) {
			if (_(data).has(key)) model[key] = data[key];
		});

		var stack = this.get('editStack');
		if (force) {
			stack = new Backbone.Collection();
		}
		stack.add(new Backbone.Model(model));
		this.set('editStack', stack);
	},
	isDataMatch: function (data) {
		var currentRawModel = this.getCurrentModel().attributes;
		return _.every(this.dataKeys, key => currentRawModel[key] == data[key]);
	},
	isDataMatchOriginal: function(data) {
		var currentRawModel = this.getOriginalModel().attributes;
		return _.every(this.dataKeys, key => currentRawModel[key] == data[key]);
	},
	createNewModelFromChanges: function (changes) {

	},
	addToStack: function (data, status) {
		var stack = this.get('editStack');
		var stackPosition = this.get('editStackPosition');
		var currentModel = this.getCurrentModel();

		//EDIT => UNDO => EDIT clears the redo stack
		if (stack.length > stackPosition + 1) {
			for (var i = stack.length; i > stackPosition; i--) {
				stack.remove(stack.at(i));
			}
		}

		var model = {};

		_.each(this.dataKeys, function (key) {
			if (_(data).has(key)) model[key] = data[key];
		});

		var isModelChanged = (currentModel.get('row1').trim() == data['row1'].trim() &&
			currentModel.get('row2').trim() == data['row2'].trim() &&
			currentModel.get('frameEnd') == data['frameEnd'] &&
			currentModel.get('frameStart') == data['frameStart'] &&
			currentModel.get('italic') == data['italic']) == false;

		if (!isModelChanged) {
			return;
		}

		stack.add(new Backbone.Model(model));
		if (typeof status !== 'undefined')  {
			this.set('status', status); 
		}

		this.set('editStackPosition', stack.length - 1);
	},
	undoFromDeleted: function () {
		//private
		var self = this;
		
		// Check for timestamp collision BEFORE showing confirmation
		if (self.timestampCollision(0)) {
			notifications.error('Cannot restore: Subtitle time overlaps with adjacent subtitle.');
			return true;
		}
		
		customConfirm("This action will restore your subtitle.\n\nAre you sure you want to continue?", function() {
			// OK clicked
			if (self.get('editStackPosition')) {
				dispatcher.emit(dispatcher.events.DB_UPDATE_SUBTITLE, {
					item: self,
					force: true,
					status: STATUSES.UPDATED
				});
				self.set('status', STATUSES.UPDATED);
			} else {
				dispatcher.emit(dispatcher.events.DB_RESET_SUBTITLE, {
					item: self,
					status: STATUSES.DEFAULT
				});
				self.set('status', STATUSES.DEFAULT);
			}

			dispatcher.emit(dispatcher.events.UPDATE_SUB_DISPLAY);
			dispatcher.emit(dispatcher.events.COLLECTION_INDEX_CHANGED);
			dispatcher.emit(dispatcher.events.UPDATE_SUB);
		});

		return true;
	},
	undoToOriginal: function () {
		var self = this;
		customConfirm("This undo will revert the subtitle to its original values.\n\nAre you sure you want to continue?", function() {
			// OK clicked
			self.set('editStackPosition', 0);

			var newStatus = self.statusNew() ? self.get('status') : STATUSES.DEFAULT;
			
			dispatcher.emit(dispatcher.events.DB_RESET_SUBTITLE, {
				item: self,
				status: newStatus
			});

			self.set('status', newStatus);
			dispatcher.emit(dispatcher.events.UPDATE_SUB);
			dispatcher.emit(dispatcher.events.UPDATE_SUB_DISPLAY);
		});

		return true;
	},
	
	undo: function () {
		if (this.get('status') == STATUSES.DELETED) {
			return this.undoFromDeleted();
		}

		if (this.timestampCollision(-1)) {
			return true;
		}

		var stackPosition = this.get('editStackPosition');
		var newStackPosition = stackPosition - 1;
		var isEmptyUndoStack = stackPosition == 0;
		if (isEmptyUndoStack) {
			// dispatcher.emit(dispatcher.events.DELETE_SUBTITLE); //Remove this behavior for now
			return true;
		}

		if (newStackPosition == 0 && !this.isNew()) {
			return this.undoToOriginal();
		}

		var row1Length = this.getCurrentModel().get('row1') ? this.getCurrentModel().get('row1').length : 0;
		var row2Length = this.getCurrentModel().get('row2') ? this.getCurrentModel().get('row2').length : 0;
		var isEmpty = row1Length + row2Length == 0;

		this.set('editStackPosition', newStackPosition);
		var newStatus = this.statusNew() ? this.get('status') : STATUSES.DEFAULT;

		dispatcher.emit(dispatcher.events.UPDATE_SUB);
		dispatcher.emit(dispatcher.events.UPDATE_SUB_DISPLAY);
		try {
			dispatcher.emit(dispatcher.events.DB_UPDATE_SUBTITLE, {
				item: this,
				changes: this.getCurrentModel().attributes,
				status: newStatus
			});
		}
		catch(e) {
			return;
		}

		if (newStackPosition == 0) {
			this.set('status', newStatus);
		}

		return true;
	},
	redo: function () {
		if (this.timestampCollision(1)) return true;

		var stack = this.get('editStack');
		var stackPosition = this.get('editStackPosition');
		var statusToRestore = this.get('status') == STATUSES.NEW ?
			STATUSES.NEW :
			STATUSES.UPDATED;

		if (stackPosition + 1 == stack.length) {
			return false;
		}

		this.set('editStackPosition', stackPosition + 1);
		dispatcher.emit(dispatcher.events.UPDATE_SUB);
		dispatcher.emit(dispatcher.events.UPDATE_SUB_DISPLAY);
	
		try {
			dispatcher.emit(dispatcher.events.DB_UPDATE_SUBTITLE, {
				item: this,
				changes: this.getCurrentModel().attributes,
				status: statusToRestore
			});
		}
		catch(e) {
			return;
		}
		
		this.set('status', statusToRestore);

		return true;
	},

	getPreviousSubtitle: function () {
		var index = this.collection.indexOf(this);
		var previousSubtitle, previousSubModel;
		var previousSubtitleIndex = index;

		previousSubtitleIndex -= 1;
		while (!previousSubtitle && previousSubtitleIndex >= 0) {
			previousSubModel = this.collection.at(previousSubtitleIndex);

			if (previousSubModel.get('status') != STATUSES.DELETED) previousSubtitle = previousSubModel;
			previousSubtitleIndex -= 1;
		}

		return previousSubtitle;
	},

	getNextSubtitle: function () {
		var index = this.collection.indexOf(this);
		var collectionLength = this.collection.length;
		var nextSubtitle, nextSubModel;
		var nextSubtitleIndex = index;

		nextSubtitleIndex += 1;
		while (!nextSubtitle && nextSubtitleIndex < collectionLength) {
			nextSubModel = this.collection.at(nextSubtitleIndex);

			if (nextSubModel.get('status') != STATUSES.DELETED) nextSubtitle = nextSubModel;

			nextSubtitleIndex += 1;
		}

		return nextSubtitle;
	},

	timestampCollision: function (dir) {
		var newPosition = this.get('editStackPosition') + dir;

		var subtitle = this.get('editStack').at(newPosition);

		if (!subtitle) return;

		var previousSubtitle = this.getPreviousSubtitle();
		if (previousSubtitle) previousSubtitle = previousSubtitle.getCurrentModel();
		if (previousSubtitle &&
			subtitle.get('frameStart') <= previousSubtitle.get('frameEnd')) {
			notifications.info('Subtitle time overlaps with previous subtitle.');
			return true;
		}

		var nextSubtitle = this.getNextSubtitle();
		if (nextSubtitle) nextSubtitle = nextSubtitle.getCurrentModel();
		if (nextSubtitle &&
			subtitle.get('frameEnd') >= nextSubtitle.get('frameStart')) {
			notifications.info('Subtitle time overlaps with next subtitle.');
			return true;
		}

		return false;
	},

	getCurrentModel: function () {
		return this.get('editStack').at(this.get('editStackPosition'));
	},

	getOriginalModel: function() {
		return this.get('editStack').at(0);
	},

	getOriginalStatus: function() {
		return this.statusNew() ? this.get('status') : STATUSES.DEFAULT;
	},

	isNew: function () {
		return this.get('editStackPosition') == 1 && this.statusNew();
	},

	statusNew: function () {
		return this.get('status') == STATUSES.NEW_PREINSERTED || this.get('status') == STATUSES.NEW;
	},

	getSubtitleIndex: function (params) {
		if (params && params.shouldIgnoreDeleted) {
			return this.collection.filter(item => item.get('status') != STATUSES.DELETED)
				.indexOf(this);
		}
		return this.collection.indexOf(this);
	}
});

var SubtitleCollection = Backbone.Collection.extend({
	model: SubtitleModel
});

module.exports = {
	Model: SubtitleModel,
	Collection: SubtitleCollection,
	VARIABLES: {
		STATUSES: STATUSES,
		CLASS_NAMES: CLASS_NAMES
	}
};


// WEBPACK FOOTER //
// ./app/scopes/subtitle.js